import './App.scss';
import { Routes, Route, useLocation } from 'react-router-dom'
import Home from './routes/home';
import About from './routes/about';
import Background from './routes/background';
import Skills from './routes/skills';
import Projects from './routes/projects';
import Contact from './routes/contact';
import Navbar from './components/navBar';

import { useCallback } from 'react';
import Particles from 'react-tsparticles';
import { loadFull } from 'tsparticles';
import particles from './utils/particles';

function App() {
  const locatioon = useLocation();

  const handleParticleInit = async (main) => {
    await loadFull(main)
  }

  const renderParticleJSHomePage = locatioon.pathname == "/";

  return (
    <div className="App">
      {/* particles js*/}
      {renderParticleJSHomePage &&
        <Particles id="particles" options={particles} init={handleParticleInit} />
      }
      {/* Navbar */}
      {/* <div className='popupmenu'> */}
        <Navbar />
      {/* </div> */}


      {/* Main page content */}
      <div className='mainArea'>
        <Routes>
          <Route index path="/" element={<Home />} />
          <Route path='/about' element={<About />} />
          <Route path='/background' element={<Background />} />
          <Route path='/skills' element={<Skills />} />
          <Route path='/projects' element={<Projects />} />
          <Route path='/contact' element={<Contact />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
